export const DEFAULT_BACKGROUND = '#5f259f'